/* eslint-disable @typescript-eslint/ban-ts-comment,no-param-reassign */
import type { Watch } from '@/modules/common/types';
import type { Channel } from '@/modules/common/types/channel';

const watchMapping = {
  allowComments: 'comments',
  allowDownload: 'download',
  allowTranscriptDownload: 'transcriptDownload',
  appearanceMode: 'appearance',
  autoplayNextVideo: 'autoplayNext',
  autoplayVideo: 'autoplay',
  autoplayVideoMobile: 'autoplayMobile',
  customCss: 'css',
  customJs: 'js',
  deepSearchRedirect: 'dsRedirect',
  deepSearchTags: 'dsTags',
  delayTimeVideoPreview: 'delayPreview',
  dockToHeaderMobile: 'dockMobile',
  doubleClickPlaybackFlow: 'dblClickFlow',
  enableSlides: 'slides',
  enabledTags: 'tags',
  excludedChips: 'excludedTags',
  genAi: 'genAI',
  genAiVideoCount: 'genAICount',
  hubBgColor: 'bg',
  hubColor: 'color',
  hubFontFamily: 'font',
  hubFontSize: 'fontSize',
  hubOffsetBottom: 'offsetBottom',
  hubOffsetTop: 'offsetTop',
  isEnableDeepSearch: 'deepSearch',
  isEnableHighlights: 'highlights',
  isEnableSearch: 'search',
  isEnableVideoPreview: 'videoPreview',
  layoutPopupSize: 'popupSize',
  layoutType: 'layout',
  orderOfTabs: 'tabOrder',
  playerWidgetOrigin: 'widgetOrigin',
  playerWidgetPartUrl: 'widgetPath',
  sTitleFontSize: 'sTitleSize',
  sVidInfoFontSize: 'sVidInfoSize',
  sVidTitleFontSize: 'sVidTitleSize',
  scDescColor: 'cDescColor',
  scDescFontSize: 'cDescSize',
  scTitleColor: 'cTitleColor',
  scTitleFontSize: 'cTitleSize',
  scVidInfoColor: 'cInfoColor',
  scVidTitleColor: 'cVidTitleColor',
  scVidTitleFontSize: 'cVidTitleSize',
  searchBarPlaceholder: 'searchPlaceholder',
  searchButtonLabel: 'searchLabel',
  seoSitemapUrl: 'sitemap',
  shouldEmailShare: 'emailShare',
  shouldPostToSocial: 'socialShare',
  showBackButtonMobile: 'backMobile',
  soundAtStart: 'sound',
  soundAtStartMobile: 'soundMobile',
  supportSEO: 'seo',
  tagThresholdCount: 'tagCount',
  tagThresholdMax: 'tagMax',
  tagThresholdMin: 'tagMin',
  useAnyclipService: 'shareService',
  videoEngagementControls: 'engagement',
};

const channelMapping = {
  bgColor: 'bg',
  cpTitleColor: 'cTitleColor',
  cpTitleFontSize: 'cTitleSize',
  cpVidInfoColor: 'cVidInfoColor',
  cpVidInfoFontSize: 'cVidInfoSize',
  cpVidTitleColor: 'cVidTitleColor',
  cpVidTitleFontSize: 'cVidTitleSize',
  logoBgColor: 'bgLogo',
};

export const castToOldWatchFields = (props: Watch) => {
  Object.entries(watchMapping).forEach(([key, value]: [string, string]) => {
    // @ts-expect-error
    if (props[key] !== undefined) {
      // @ts-expect-error
      props[value] = props[key];
    }
  });

  if (Object.prototype.hasOwnProperty.call(props, 'videoPlaybackFlow')) {
    // @ts-ignore
    props.dblClickFlow = props.videoPlaybackFlow === 'TWO_CLICK';
  }

  return props;
};

export const castToOldChannelFields = (props: Channel) => {
  Object.entries(channelMapping).forEach(([key, value]: [string, string]) => {
    // @ts-expect-error
    if (props[key] !== undefined) {
      // @ts-expect-error
      props[value] = props[key];
    }
  });

  return props;
};
